import React, { useState, useEffect } from "react";
import { moneyFormat } from "../../ultil";
import TextTitle from "../Text/TextTitle";
import TextTitle1 from "../Text/TextTitle1";
import TextBody from "../Text/TextBody";
import TextBody2 from "../Text/TextBody2";
import TextHead from "../Text/TextHead";
import TextPrice from "../Text/TextPrice";
import TextPriceOld from "../Text/TextPriceOld";
import TextQuantity from "../Text/TextQuantity";
import TextOutOfStock from "../Text/TextOutOfStock";
import {
  Box,
  Divider,
  Button,
  ButtonBase,
  ButtonGroup,
} from '@mui/material';

const HeyUDownload = ({platform}) => {
  return <Box sx={{width: '100%', padding: '8px 16px', display: 'flex'}}>
    <Box>
      <img src="/image/logo-heyu-tet.jpg" width="80px" height="80px" style={{borderRadius: '16px'}}/>
    </Box>
    <Box flexGrow={1} px={2} display="flex" justifyContent="center" flexDirection="column">
      <TextTitle>
        HeyU
      </TextTitle>
      <TextBody2 color="#B3B5B6">
        All you need
      </TextBody2>
    </Box>
    <Box px={2} display="flex" justifyContent="center" flexDirection="column">
    {!platform ? <img
        src="/image/qrcode_heyu.png"
        width="80px"
        height="80px"
      />:
      <Button
        onClick={(e) => {
          window.location.replace("sanshipvietnam://");
          setTimeout(function () {
            window.location.replace(platform === "Android"
            ? "https://play.google.com/store/apps/details?id=com.sanship.pro"
            : "https://itunes.apple.com/us/app/san-ship/id1179627110");
          }, 500);
        }}
        size="large" variant="contained" style={{width: '117px', borderRadius: '16px', fontSize: '16px', textTransform: 'none', backgroundColor: '#1589D8', color: '#ffffff', fontWeight: 600}}>
        Mở
      </Button>
    }
    </Box>
  </Box>
}

export default HeyUDownload
